import { Badge, Box, Divider, Flex, Image, Progress, Text } from "theme-ui";
import { BadgeData } from "../../../../@types";
import { getBadgeBackground, gradients } from "../../../utils/CustomHandler";
import { bucketUrl } from "../../../utils/global";

const progressGradients = {
    default: "linear-gradient(141.14deg, #B6947E 14.91%, #F8DAC8 93.31%)",
    gold: "linear-gradient(156.58deg, #FFF5DE 17.17%, #CFA365 84.45%)",
    bronze: "linear-gradient(141.14deg, #B6947E 14.91%, #F8DAC8 93.31%)",
    silver: "linear-gradient(137.95deg, #7A96AC 9.42%, #C2D4E1 31.79%, #D2D2D2 40.63%, #ABBDC8 59.1%, #BCCAD7 95.24%)",
    platinum: "linear-gradient(222.28deg, #7ABBAC 20.01%, #B1FFEF 36.93%, #8AD2C3 52.27%, #6CA196 77.57%, #35544E 101.47%)"
};

const getProgressColor = (background: string) => {
    switch (background) {
        case gradients.GOLD:
            return progressGradients.gold;
        case gradients.SILVER:
            return progressGradients.silver;
        case gradients.BRONZE:
            return progressGradients.bronze;
        case gradients.PLATINUM:
            return progressGradients.platinum;
        default:
            return progressGradients.default;
    }
};
const BadgeCard: React.FC<BadgeData> = ({ title, progress, level, icon, badges, bgBadge }) => {
    const background = getBadgeBackground(badges);
    const progressColor = getProgressColor(background);


    return (
        <>
            <Box
                sx={{
                    background: background || "linear-gradient(135deg, #B6947E, #8F6959, #FECFB3, #AC836E, #B6947E, #F8DCCB)",
                    borderRadius: "20px",
                    pt: [1, 2, 3, 4],
                    pb: 7,
                    px: 7,
                    width: "100%",
                }}
            >
                <Flex sx={{ justifyContent: "space-between", alignItems: "center" }}>
                    <Flex sx={{ alignItems: "center", gap: 2 }}>
                        <Badge
                            sx={{
                                bg: bgBadge || "#60B680",
                                color: "white",
                                fontSize: "17px",
                                fontWeight: "bold",
                                px: '10px',
                                py: '6px',
                                borderRadius: "12px",
                                display: "flex",
                                alignItems: "center",
                                gap: 1,
                            }}
                        >
                            {<img src={icon} style={{ width: '25px', height: '25px' }} />}
                            <span>{title}</span>
                        </Badge>

                    </Flex>
                </Flex>
                <Divider sx={{ color: 'white' }} opacity={2} my={[3, 3, 3]} />
                {level != undefined && (
                    <Text sx={{ fontSize: ['16px'], fontWeight: 500, mt: 2, color: 'white', lineHeight: '24px' }}>
                        Achievements - {level}
                    </Text>
                )}
                <Flex className="d-flex justify-content-between" sx={{ mt: 3, alignItems: 'center' }}>

                    {badges?.map((badge: any, index: number) => (
                        <Image key={index} src={bucketUrl + badge?.icon} sx={{ width: ['40px', '40px', '80px'], height: ['40px', '40px', '80px'], objectFit: 'contain', flexShrink: 0, maxWidth: '100%' }} />
                    ))}

                </Flex>
                <Box sx={{ mt: 4, position: "relative" }}>
                    <Progress
                        max={100}
                        value={progress}
                        sx={{
                            height: "12px",
                            width: '90%',
                            background: progressColor || "rgba(255, 255, 255, 0.3)",
                            borderRadius: "20px",
                            overflow: "hidden",
                            "&::-webkit-progress-bar": {
                                background: "#fdfdfd",
                            },
                            "&::-webkit-progress-value": {
                                background: progressColor || "#fdfdfd",
                            },
                        }}
                    />

                    {/* Progress Percentage */}
                    <Box
                        sx={{
                            position: "absolute",
                            right: "-10px",
                            top: "-8px",
                            background: progressColor || "rgba(0, 0, 0, 0.3)",
                            color: "white",
                            fontSize: "12px",
                            px: 2,
                            py: 1,
                            borderRadius: "6px",
                        }}
                    >
                        {progress}%
                    </Box>
                </Box>
            </Box>
        </>

    )
}

export default BadgeCard